import DOMPurify from 'dompurify';

export const useClearCss = () => {

  const clearCss = (htmlStr: string): string => {
    return DOMPurify.sanitize(htmlStr, { FORBID_ATTR: ['style'] });
  };

  return { clearCss };
};
